<template>
  <div id="app">
   <!-- <header-section></header-section> -->
    <main>
      <router-view />
      <FirstVisitGuide />
      <OnboardingTour />
    </main>
   <!-- <footer-section></footer-section> -->
  </div>
</template>

<script>
import FirstVisitGuide from "./components/firstVisitGuide.vue";
import OnboardingTour from "./components/OnboardingTour.vue";

export default {
  components: {
    FirstVisitGuide,
    OnboardingTour,
  },
  data() {
    return {
      inactivityTimer: null,
      inactivityLimit: 10 * 60 * 1000 // 10 minutes
    }
  },

  mounted() {
    this.startInactivityTimer()

    // detect user activity
    window.addEventListener("mousemove", this.resetTimer)
    window.addEventListener("keydown", this.resetTimer)
    window.addEventListener("click", this.resetTimer)
    window.addEventListener("scroll", this.resetTimer)
  },

  beforeUnmount() {
    window.removeEventListener("mousemove", this.resetTimer)
    window.removeEventListener("keydown", this.resetTimer)
    window.removeEventListener("click", this.resetTimer)
    window.removeEventListener("scroll", this.resetTimer)
  },

  methods: {

    startInactivityTimer() {
      this.inactivityTimer = setTimeout(() => {
        this.handleLogout()
      }, this.inactivityLimit)
    },

    resetTimer() {
      clearTimeout(this.inactivityTimer)
      this.startInactivityTimer()
    },

    handleLogout() {
      localStorage.removeItem("token")
      localStorage.removeItem("user")

      this.$router.push("/")
    }
  }
}
</script>

<style>
/* Inter as a variable font so the intermediate weights the design system uses
   (550, 650) render properly instead of being rounded or synthesised. */
@import url('https://fonts.googleapis.com/css2?family=Inter:wght@300..800&display=swap');
@import url('https://fonts.googleapis.com/css2?family=JetBrains+Mono:wght@400;500&display=swap');

/* Legacy aliases — kept so nothing that still references them breaks, but they
   now resolve to the dashboard design tokens in assets/css/design.css. */
:root {
  --primary: var(--dash-primary);
  --primary-dark: var(--dash-primary-hover);
  --secondary: var(--dash-success);
  --dark: var(--dash-ink);
  --light: var(--dash-bg);
  --gray: var(--dash-muted);
  --border: var(--dash-line);
  --font-sans: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
  --font-mono: 'JetBrains Mono', 'IBM Plex Mono', monospace;
}

* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

body {
  font-family: var(--font-sans);
  color: var(--dark);
  line-height: 1.6;
}

.mono{
  font-family: var(--font-mono);
}
.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
}
</style>